
export interface MCARS080EntrySearchHistoryInfoOutDto {
  [key: string]: any

  /** 直近のエントリー検索履歴 */
  recentEntrySearchHistory: string
  
  /** 表示用直近のエントリー検索履歴 */
  recentEntrySearchHistoryDisplay: string
  
  /** 前回のエントリー検索履歴 */
  previousEntrySearchHistory: string
  
  /** 表示用前回のエントリー検索履歴 */
  previousEntrySearchHistoryDisplay: string
}

export const initMCARS080EntrySearchHistoryInfoOutDto: MCARS080EntrySearchHistoryInfoOutDto = {
  /** 直近のエントリー検索履歴 */
  recentEntrySearchHistory: '',

  /** 表示用直近のエントリー検索履歴 */
  recentEntrySearchHistoryDisplay: '',

  /** 前回のエントリー検索履歴 */
  previousEntrySearchHistory: '',
  
  /** 表示用前回のエントリー検索履歴 */
  previousEntrySearchHistoryDisplay: '',
}
